import { useState } from 'react';
import { Button, Typography } from '@mui/material';
import { BaseDialog } from '@/components/shared/base-dialog';
import { ReorderPaths } from './reorder-paths';
import { useNotification } from '@/context/notification';
import type {
  LearningPathItem,
  PathType,
} from '@/data/learning-path/interfaces';
import { useReorderPaths } from '@/data/learning-path/path-management';

interface ReorderPathsDialogProps {
  paths: LearningPathItem[];
  scope: PathType;
  onClose: () => void;
}

export const ReorderPathsDialog = ({
  paths,
  scope,
  onClose,
}: ReorderPathsDialogProps) => {
  const [orderedPaths, setOrderedPaths] = useState(paths);
  const { mutate: reorderPaths, isPending } = useReorderPaths();
  const { toast } = useNotification();

  const handleSubmit = () => {
    reorderPaths(
      { scope, paths: orderedPaths.map(({ id }) => ({ id })) },
      {
        onSuccess: () => onClose(),
        onError: () => {
          toast({
            content: 'Ocorreu um erro ao salvar a nova ordem. Tente novamente.',
            type: 'error',
          });
        },
      }
    );
  };

  return (
    <BaseDialog
      title="Reordenar trilhas"
      onClose={onClose}
      actionsComponent={
        <>
          <Button onClick={onClose}>Cancelar</Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            loading={isPending}
          >
            Salvar
          </Button>
        </>
      }
    >
      <Typography mb={2}>Altere a ordem arrastando as trilhas</Typography>
      <ReorderPaths paths={orderedPaths} updatePaths={setOrderedPaths} />
    </BaseDialog>
  );
};
